/**
 * useGameLoop — drives the simulation clock.
 *
 * • setInterval at the current speed; paused when tab hidden (iOS Safari
 *   throttles timers aggressively anyway — we embrace it for determinism).
 * • Pauses automatically while an event modal or exit offer awaits a decision.
 */

import { useEffect } from 'react';
import { SPEED_MS, useGameStore } from '@/store/gameStore';

export function useGameLoop(): void {
  const speed = useGameStore((s) => s.speed);
  const state = useGameStore((s) => s.state);
  const tick = useGameStore((s) => s._tick);

  const blocked = !state || state.gameOver !== null || state.pendingEventId !== null || state.exitOffer !== null;

  useEffect(() => {
    if (speed === 0 || blocked) return;
    const id = window.setInterval(tick, SPEED_MS[speed]);
    return () => window.clearInterval(id);
  }, [speed, blocked, tick]);
}
